import { createContext, useState } from 'react'
import { getVisits, getVisit } from '../api/visit'

const VisitContext = createContext({
  eachData: null,
  data: [],
  setEachData: () => {},
  getEachData: () => {},
  setData: () => {},
  getData: () => {},
})

export function VisitContextProvider(props) {
  const [visits, setVisits] = useState([])
  const [visit, setVisit] = useState({})
  const context = {
    eachData: visit,
    data: visits,
    getData: async (params) => {
      let response = await getVisits(params)
      setVisits(response)
    },
    getEachData: async (params) => {
      let response = await getVisit(params)
      response.tableData = response.tableData
        ? JSON.parse(response.tableData)
        : []
      setVisit(response)
      return response
    },
  }
  return (
    <VisitContext.Provider value={context}>
      {props.children}
    </VisitContext.Provider>
  )
}

export default VisitContext
